import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    'Real world attacks against current computer vision models',
    'Theoretic understanding of adversarial machine learning and certifiable robustness',
    'Vulnerabilities and potential solutions to adversarial machine learning in real-world applications, e.g., autonomous driving, 3D object recognition, and large-scale image retrieval',
    'Repeatable experiments adding to the knowledge about adversarial examples on image, video, audio, point cloud and other data',
    'Real world data distribution drift and its implications to model generalization and robustness',
    'Detection and defense mechanisms against adversarial examples for computer vision systems',
    'Novel challenges and discoveries in adversarial machine learning for computer vision systems',
]
export default function Call() {
    return <div className="call-box">
         <div className="page-call">
            <div className="call-title">Call for Papers</div>
            <div className="title-top">
                <p>Topics</p>
                <span>Topics include but are not limited to:</span>
            </div>
            <Row className="list-ul">
                {arrs.map((item, index) => (
                    <Col xl={12} span={24} className="list-li" key={index}> 
                        <b />
                        {item}
                    </Col>
                ))}
                <Col>
                    <div className="link" onClick={() => { window.open('https://cmt3.research.microsoft.com/cvpramlcv2021') }}>CMT link</div>
                </Col>
                <Col className="list-list">
                    Submissions need to be anonymized, and follow the CVPR 2021 template described <a href="http://cvpr2021.thecvf.com/node/33#call-for-paper">here</a>. Submissions should include at most 4 pages, excluding the references and appendices. Accepted papers will not be included in the official CVPR proceedings.
                </Col>
            </Row>
        </div>
    </div>
   
}

